// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "th[data-v-3c044a56],\ntd[data-v-3c044a56] {\n  white-space: nowrap;\n}\nth[data-v-3c044a56]:last-child,\ntd[data-v-3c044a56]:last-child {\n  position: sticky;\n  right: 0;\n  background: #fff;\n  z-index: 999;\n}\n.mx-input[data-v-3c044a56] {\n  height: calc(1.5em + 0.5rem + 2px);\n  padding: 0.25rem 0.5rem;\n  font-size: 0.7875rem;\n  line-height: 1.5;\n  border-radius: 0.2rem;\n  min-width: 123px;\n}", ""]);
// Exports
module.exports = exports;
